import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MovementPerceptionService } from 'src/app/service/movement-perception.service';
import { MatDialog } from '@angular/material/dialog';
import { LoadingDialog } from '../dialogs/loading/loading.dialog';
import { TranslateService } from '@ngx-translate/core';
import { TaskService } from 'src/app/service/tasks.service';


@Component({
  selector: 'app-movement-perception',
  templateUrl: './movement-perception.component.html',
  styleUrls: ['./movement-perception.component.css']
})
export class MovementPerceptionComponent implements OnInit {

  done = false
  charged2 = false
  started = false
  gettingResolution = true
  gettingResolutionStarted = false
  demo = true
  ready = true
  listenSpaceBar = false
  fullScreen = false
  testView = false
  saving = false
  finished = false

  resX: number
  resY: number
  answers = []

  constructor(private router: Router,
    private movementPerceptionService: MovementPerceptionService,
    private dialog: MatDialog,
    public translate: TranslateService,
    private taskService: TaskService) { }

  ngOnInit(): void {
    this.movementPerceptionService.check_exp()
      .then((data) => {
        this.done = data.body.valid
        this.charged2 = true

      })
  }

  start() {
    this.started = true
    this.listenSpaceBar = true
  }

  startResolution() {
    this.gettingResolutionStarted = true
  }

  setFullScreen = (newVal: boolean) => {
    this.fullScreen = newVal
  }

  endDemo = () => {
    this.demo = false
    this.testView = false
    this.started = false
  }

  setResolution = (resX: number, resY: number) => {
    this.resX = resX
    this.resY = resY
  }

  endGettingResolution = () => {
    this.gettingResolution = false
  }

  startTest = () => {
    this.testView = true
    this.started = true
  }

  redoDemo = () => {
    this.demo = true
    this.startTest()
  }

  setAnswers = (newAnswers: Array<any>) => {
    this.answers = [...newAnswers]
  }

  save = async () => {
    this.testView = false
    this.saving = true
    const dialogRef = this.dialog.open(LoadingDialog, { disableClose: true })
    await this.movementPerceptionService.save(this.answers).then(() => {
      this.taskService.saveCompletedTask({ "type": "MovementPerception" })
    })
    dialogRef.close()
    this.saving = false
    this.finished = true
    setTimeout(() => {
      this.router.navigate([''])
    }, 3000)
    
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (this.listenSpaceBar && event.key === '') {

    }
  }

}
